import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { propertyLacksPermissionSectionMaker } from 'App/Map/PanelDetails/_utils/propertyLacksPermissionSectionMaker'
import { selectedPropertyHasPermission } from 'App/Map/PanelDetails/_utils/selectedPropertyHasPermission'
import type { GridTableContentSection } from 'components/GridTable/types'
import { translate } from 'i18n/i18n'
import type { TPoint } from 'stores/fieldAssetStore/helperTypes'
import { DropdownSelectorPropertyFlowMeter } from '../flowMeter/DropdownSelectorPropertyFlowMeter'
import { CumulativeSummaryTable } from './CumulativeSummaryTable'

const checkPermission = () =>
  selectedPropertyHasPermission({ permission: 'VIEW_IRRIGATION_FLOW_METER_DETAILS' })

export const flowMeterTotals = ({
  data,
  points,
}: {
  data: routes.Values.Response
  points: TPoint[]
}): GridTableContentSection => {
  const title = translate.phrases.banyanApp('Flow Meter Totals')

  const commonReturnItems = {
    title,
    fieldAssetPicker: <DropdownSelectorPropertyFlowMeter />,
    id: 'summary-grid-flowMeter-totals',
  }

  if (!checkPermission() || points.length === 0) return propertyLacksPermissionSectionMaker(commonReturnItems)

  const flowMeterData = Object.fromEntries(
    Object.entries(data.points || {}).filter(
      ([, flowMeterValues]) => (flowMeterValues?.values?.irrigationFlowMeter || []).length > 0,
    ),
  )

  return {
    title,
    fieldAssetPicker: <DropdownSelectorPropertyFlowMeter />,
    id: 'summary-grid-flowMeter-totals',
    belowFullWidthItems: [{ content: <CumulativeSummaryTable points={points} data={flowMeterData} /> }],
  }
}
